const fr = {
  common: {
    facts: "En chiffres",
    why: "Pourquoi choisir l'Hotel Ciutat Martorell",
    related: "Cela peut aussi vous intéresser",
    quoteEyebrow: "Parlez-nous de votre mariage",
  },
  nearSeat: {
    seoTitle: "Hôtel près de SEAT-CUPRA Martorell · à 5 min de l'usine",
    seoDesc: "Hôtel 4★ à 5 minutes de l'usine SEAT-CUPRA et des zones industrielles de Martorell. Tarifs entreprises, WiFi fibre, parking, restaurant et gare à 100 m.",
    eyebrow: "Hôtel pour les visites chez SEAT-CUPRA",
    title: ["Votre hôtel à 5 minutes", "de SEAT-CUPRA Martorell"],
    intro: "Fournisseurs, ingénieurs, formateurs et équipes projet séjournent chez nous parce que l'usine et les zones industrielles de Martorell sont à deux pas, et le train pour Barcelone à 100 mètres.",
    facts: [
      { k: "Usine SEAT-CUPRA", v: "5 min en voiture" },
      { k: "Renfe et FGC", v: "100 m" },
      { k: "Barcelone", v: "30 min" },
      { k: "Aéroport El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Conçu pour le séjour professionnel", p: "Chambres de 21 m² avec bureau, WiFi fibre gratuit et climatisation. Petit-déjeuner buffet de 06h30 à 10h30 pour arriver à l'heure à l'équipe du matin, réception 24 h pour les arrivées tardives et Business Corner pour imprimer ou boucler un rapport." },
      { h: "Tarifs entreprises et facturation centralisée", p: "Pour les entreprises qui visitent régulièrement l'usine, nous proposons des tarifs négociés, une facturation centralisée et une gestion rapide des réservations d'équipes. Indiquez-nous votre volume approximatif de nuitées et nous préparons une proposition." },
      { h: "Réunions et formations à côté de l'usine", p: "Trois salles à la lumière du jour de 35 à 220 m² pour formations de fournisseurs, kick-offs ou audits, avec projecteur, fibre et pause-café. Et le restaurant My Bar pour les déjeuners d'affaires, avec menu exécutif du lundi au vendredi." },
    ],
    why: [
      "À 5 minutes en voiture de l'usine SEAT-CUPRA et des zones industrielles de Martorell",
      "Parking privé dans l'hôtel (avec supplément)",
      "WiFi fibre gratuit et bureau dans toutes les chambres",
      "Petit-déjeuner dès 06h30 et réception 24 heures",
      "Tarifs entreprises avec facturation centralisée",
    ],
    faqTitle: "Séjourner près de SEAT-CUPRA",
    cta: { title: "Réservation directe ou tarif entreprise", text: "Réservez sur le site officiel au meilleur prix garanti ou demandez un tarif entreprise pour votre équipe.", secondary: "Tarifs entreprises", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "Hôtel pour entreprises" },
      { to: "meetingRooms", label: "Salles de réunion" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "Où loger pour un déplacement professionnel à Martorell" },
    ],
  },
  nearMontserrat: {
    seoTitle: "Hôtel près de Montserrat · à 20 min du monastère",
    seoDesc: "Hôtel 4★ à Martorell, à 20 minutes en voiture de Montserrat et avec le train FGC à 100 m vers la crémaillère. Une base confortable pour le monastère et Barcelone.",
    eyebrow: "Hôtel pour visiter Montserrat",
    title: ["Montserrat à 20 minutes,", "Barcelone à 30"],
    intro: "Martorell est le point intermédiaire idéal : le monastère et les montagnes de Montserrat le matin, Barcelone l'après-midi. Et le soir, une chambre calme avec restaurant et parking.",
    facts: [
      { k: "Monastère de Montserrat", v: "20 min en voiture" },
      { k: "Train FGC vers la crémaillère", v: "à 100 m de l'hôtel" },
      { k: "Barcelone", v: "30 min" },
      { k: "Aéroport El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Comment rejoindre Montserrat depuis l'hôtel", p: "En voiture, 20 minutes jusqu'au monastère ou jusqu'au parking de la crémaillère à Monistrol. En transports en commun, la gare FGC est à 100 mètres : ligne R5 jusqu'à Monistrol de Montserrat puis montée en crémaillère, ou jusqu'à Montserrat-Aeri puis montée en téléphérique." },
      { h: "Une journée en montagne, une nuit de repos", p: "Après la basilique, l'Escolania ou une randonnée jusqu'à Sant Jeroni, retrouvez une chambre de 21 m² avec climatisation, salle de bain avec douche et WiFi fibre. Dînez au restaurant My Bar : cuisine méditerranéenne de marché et vins du Penedès." },
      { h: "Combinez Montserrat et Barcelone", p: "Depuis les gares Renfe et FGC, Barcelone est à environ 30 minutes. Consacrez une journée à Montserrat et une autre à la ville sans changer d'hôtel ni vous battre pour une place de parking au centre." },
    ],
    why: [
      "À 20 minutes en voiture du monastère de Montserrat",
      "Gare FGC à 100 mètres, avec correspondance crémaillère et téléphérique",
      "Parking privé pour laisser la voiture et se déplacer en train",
      "Restaurant My Bar avec cuisine méditerranéenne et vins du Penedès",
      "Petit-déjeuner buffet de 06h30 à 10h30 pour partir tôt en montagne",
    ],
    faqTitle: "Visiter Montserrat depuis l'hôtel",
    cta: { title: "Réservez votre base pour Montserrat", text: "Réservation directe sur le site officiel au meilleur prix garanti. Vous venez en groupe ? Demandez-nous une proposition.", secondary: "Comment venir à l'hôtel", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "Comment aller à Montserrat depuis Martorell" },
      { to: "location", label: "Situation et accès" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "Que visiter près de Martorell" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "Hôtel avec parking près de Barcelone · à 30 min en train",
    seoDesc: "Hôtel 4★ avec parking privé à Martorell, à 30 minutes de Barcelone. Laissez la voiture et rejoignez la ville en Renfe ou FGC depuis la gare à 100 m. Réservation directe.",
    eyebrow: "Hôtel avec parking",
    title: ["Garez la voiture,", "Barcelone en 30 minutes"],
    intro: "Si vous arrivez en voiture à Barcelone, dormir hors du centre est plus serein et plus simple : parking privé à l'hôtel et train direct vers la ville à 100 mètres de la porte.",
    facts: [
      { k: "Parking privé", v: "à l'hôtel" },
      { k: "Gares Renfe et FGC", v: "100 m" },
      { k: "Centre de Barcelone", v: "30 min" },
      { k: "Aéroport El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Parking privé dans l'hôtel même", p: "Places de parking privé pour les clients hébergés (avec supplément), sans chercher de place ni payer les tarifs des parkings du centre de Barcelone. Entrez et sortez à votre guise, la voiture reste à deux pas de votre chambre." },
      { h: "Barcelone en train, sans embouteillages", p: "Les gares Renfe (Rodalies) et FGC sont à 100 mètres. En 30 minutes environ, vous êtes au centre ; au retour, la voiture vous attend. Pour parcourir la province, l'A-2 et l'AP-7 sont juste à côté." },
      { h: "Un hôtel complet pour l'escapade", p: "92 chambres de 21 m² avec WiFi fibre, restaurant My Bar, salle de fitness et petit-déjeuner buffet de 06h30 à 10h30. Idéal pour les familles et les couples qui visitent Barcelone ou Montserrat en voiture." },
    ],
    why: [
      "Parking privé pour les clients à l'hôtel",
      "Trains pour Barcelone à 100 mètres : Renfe et FGC",
      "À 30 minutes de Barcelone et 25 de l'aéroport",
      "Chambres Double et Twin de 21 m² avec WiFi fibre",
      "Restaurant, salle de fitness et réception 24 h",
    ],
    faqTitle: "Le parking et l'accès à Barcelone",
    cta: { title: "Réservez avec parking et oubliez la voiture", text: "Réservation directe sur le site officiel au meilleur prix garanti ; dites-nous si vous venez en voiture.", secondary: "Services de l'hôtel", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "Comment aller de Martorell à Barcelone" },
      { to: "services", label: "Services de l'hôtel" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "Transports entre Martorell et Barcelone" },
    ],
  },
  weddingsBaix: {
    seoTitle: "Hôtel pour mariages dans le Baix Llobregat · Martorell",
    seoDesc: "Célébrez votre mariage à Martorell : salle de banquet jusqu'à 150 invités, cocktail jusqu'à 200 en terrasse, menu dégustation, chambre nuptiale et tarifs pour les invités.",
    eyebrow: "Mariages dans le Baix Llobregat",
    title: ["Votre mariage dans le Baix Llobregat,", "tout sous un même toit"],
    intro: "Cocktail en terrasse, banquet dans une salle de 220 m² à la lumière du jour, cuisine méditerranéenne maison et 92 chambres pour que personne n'ait à reprendre la route. À 30 minutes de Barcelone et bien relié à toute la comarque.",
    facts: [
      { k: "Banquet", v: "jusqu'à 150 invités" },
      { k: "Cocktail", v: "jusqu'à 200 personnes" },
      { k: "Salle de banquet", v: "220 m² à la lumière du jour" },
      { k: "Chambres", v: "92 pour vos invités" },
    ],
    sections: [
      { h: "Espaces : terrasse, salle et chambres", p: "Le cocktail de bienvenue en terrasse, le banquet dans la salle modulable de 220 m² et, en fin de soirée, la chambre nuptiale offerte et des tarifs spéciaux pour les invités qui restent dormir." },
      { h: "Cuisine maison et menu dégustation", p: "Notre équipe de cuisine prépare des menus de mariage sur mesure avec des produits méditerranéens de saison et des vins du Penedès. Avant le grand jour, nous organisons une dégustation pour valider chaque plat avec les mariés." },
      { h: "Un coordinateur dès le premier café", p: "Devis ferme sous 48 heures, sans surprise. Un coordinateur dédié gère le timing, les prestataires, le DJ et l'open bar en option pour que le couple n'ait qu'à profiter." },
    ],
    why: [
      "Facile d'accès pour les invités de Barcelone et de toute la comarque : 30 min en voiture et gare à 100 m",
      "Salle de 220 m² à la lumière du jour et terrasse pour le cocktail",
      "Chambre nuptiale offerte et tarifs spéciaux pour les invités",
      "Menu dégustation préalable et cuisine méditerranéenne maison",
      "Coordinateur dédié et devis ferme sous 48 heures",
    ],
    faqTitle: "Célébrer son mariage à l'hôtel",
    cta: { title: "Dites-nous comment vous imaginez votre mariage", text: "Indiquez-nous une date approximative, le nombre d'invités et vos envies ; nous vous répondons avec une proposition sous 48 heures." },
    related: [
      { to: "weddings", label: "Mariages à l'hôtel" },
      { to: "events", label: "Événements et célébrations" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "Salle de banquet" },
    ],
  },
};

export default fr;
